import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { bind } from 'bind-event-listener';
import { Observers } from './observers';
var abortReason = {
  scroll: 'scroll',
  keypress: 'keypress',
  resize: 'resize',
  error: 'error'
};
function getViewportWidth() {
  var documentWidth;
  try {
    documentWidth = document.documentElement.clientWidth || 0;
  } catch (e) {
    documentWidth = 0;
  }
  return Math.max(documentWidth, window.innerWidth || 0);
}
function getViewportHeight() {
  var documentHeight;
  try {
    documentHeight = document.documentElement.clientHeight || 0;
  } catch (e) {
    documentHeight = 0;
  }
  return Math.max(documentHeight, window.innerHeight || 0);
}
var UNUSED_SECTOR = 0;
export var VCObserver = /*#__PURE__*/function () {
  function VCObserver(options) {
    var _this = this;
    _classCallCheck(this, VCObserver);
    /* abort logic */
    _defineProperty(this, "abortReason", {
      reason: null,
      info: '',
      timestamp: -1,
      blocking: false
    });
    _defineProperty(this, "outOfBoundaryInfo", '');
    _defineProperty(this, "viewport", {
      w: 0,
      h: 0
    });
    /* heatmap */
    _defineProperty(this, "arraySize", 0);
    _defineProperty(this, "componentsLog", {});
    _defineProperty(this, "active", false);
    _defineProperty(this, "totalTime", 0);
    _defineProperty(this, "startTime", 0);
    _defineProperty(this, "_startMeasureTimestamp", -1);
    _defineProperty(this, "ssr", {
      reactRendered: -1
    });
    _defineProperty(this, "unbind", {});
    _defineProperty(this, "getAbortReasonInfo", function () {
      if (_this.abortReason.reason === null) {
        return null;
      }
      var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
      return "".concat(_this.abortReason.reason).concat(info);
    });
    _defineProperty(this, "getVCRawData", function () {
      _this.measureStart();
      if (!_this.active) {
        _this.measureStop();
        return null;
      }
      _this.stop();
      var abortReasonInfo = _this.getAbortReasonInfo();
      _this.measureStop();
      return {
        abortReasonInfo: abortReasonInfo,
        abortReason: _objectSpread({}, _this.abortReason),
        heatmap: _this.ssrInclusiveHeatmap,
        oldHeatmap: _this.heatmap,
        outOfBoundaryInfo: _this.outOfBoundaryInfo,
        totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
        componentsLog: _objectSpread({}, _this.componentsLog),
        viewport: _objectSpread({}, _this.viewport),
        oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
        devToolsEnabled: _this.devToolsEnabled
      };
    });
    _defineProperty(this, "getVCResult", function (_ref) {
      var _objectSpread2;
      var start = _ref.start,
        stop = _ref.stop,
        tti = _ref.tti,
        prefix = _ref.prefix,
        ssr = _ref.ssr,
        vc = _ref.vc;
      var startTime = performance.now();
      // add local measurement
      var fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
      var rawData = vc !== undefined ? vc : _this.getVCRawData();
      if (rawData === null) {
        return {};
      }
      var abortReason = rawData.abortReason,
        abortReasonInfo = rawData.abortReasonInfo,
        heatmap = rawData.heatmap,
        oldHeatmap = rawData.oldHeatmap,
        outOfBoundaryInfo = rawData.outOfBoundaryInfo,
        totalTime = rawData.totalTime,
        componentsLog = rawData.componentsLog,
        viewport = rawData.viewport,
        oldDomUpdatesEnabled = rawData.oldDomUpdatesEnabled,
        devToolsEnabled = rawData.devToolsEnabled;
      if (abortReasonInfo !== null && abortReason.blocking) {
        var _ref2;
        // exposing data to devtools
        try {
          if (devToolsEnabled) {
            window.__vcNotAvailableReason = abortReasonInfo;
          }
        } catch (e) {}
        return _ref2 = {}, _defineProperty(_ref2, "".concat(fullPrefix, "vc:state"), false), _defineProperty(_ref2, "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), _defineProperty(_ref2, "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp), _ref2;
      }
      var _VCObserver$calculate = VCObserver.calculateVC({
          heatmap: heatmap,
          ssr: ssr,
          componentsLog: _objectSpread({}, componentsLog),
          viewport: viewport
        }),
        VC = _VCObserver$calculate.VC,
        VCBox = _VCObserver$calculate.VCBox,
        VCEntries = _VCObserver$calculate.VCEntries,
        totalPainted = _VCObserver$calculate.totalPainted;
      try {
        VCObserver.VCParts.forEach(function (key) {
          var duration = VC[key];
          if (duration !== null && duration !== undefined) {
            performance.measure("VC".concat(key), {
              start: start,
              duration: duration
            });
          }
        });
      } catch (e) {
        /* empty */
      }
      var ssrVC = VCObserver.calculateVC({
        heatmap: oldHeatmap,
        ssr: ssr,
        componentsLog: _objectSpread({}, componentsLog),
        viewport: viewport
      });
      var outOfBoundary = outOfBoundaryInfo ? _defineProperty({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {};
      var oldDomUpdates = oldDomUpdatesEnabled ? _defineProperty({}, "".concat(fullPrefix, "vc:old:dom"), ssrVC.VCBox) : {};
      var stopTime = performance.now();

      // exposing data to devtools
      try {
        if (devToolsEnabled) {
          window.__vc = {
            entries: VCEntries.rel,
            log: componentsLog,
            metrics: {
              '75': VC['75'],
              '80': VC['80'],
              '85': VC['85'],
              '90': VC['90'],
              '95': VC['95'],
              '98': VC['98'],
              '99': VC['99'],
              tti: tti,
              ttai: stop - start
            },
            heatmap: heatmap
          };

          // Emitting a custom event to make it available in the Chrome extension
          window.dispatchEvent(new CustomEvent('vcReady'));
        }
      } catch (e) {
        /*  do nothing */
      }
      // console.log('exposed data')

      var returnValue = _objectSpread(_objectSpread((_objectSpread2 = {
        'metrics:vc': VC
      }, _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:state"), true), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:clean"), abortReasonInfo ? false : true), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:dom"), VCBox), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:size"), viewport), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), _defineProperty(_objectSpread2, "".concat(fullPrefix, "vc:total"), totalPainted), _objectSpread2), outOfBoundary), {}, _defineProperty({}, "".concat(fullPrefix, "vc:old"), ssrVC.VC), oldDomUpdates);
      return returnValue;
    });
    _defineProperty(this, "handleUpdate", function (rawTime, intersectionRect, targetName, element, ignored) {
      _this.measureStart();
      if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
        var time = Math.round(rawTime - _this.startTime);
        var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
        _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
        if (!ignored) {
          _this.applyChangesToHeatMap(mappedValues, time, _this.ssrInclusiveHeatmap);
        }
        if (!_this.componentsLog[time]) {
          _this.componentsLog[time] = [];
        }
        _this.componentsLog[time].push({
          __debug__element: _this.devToolsEnabled ? element : null,
          intersectionRect: intersectionRect,
          targetName: targetName,
          ignored: ignored
        });
      }
      // devtools export
      _this.measureStop();
    });
    _defineProperty(this, "mapPixelsToHeatmap", function (left, top, width, height) {
      var _this$viewport = _this.viewport,
        w = _this$viewport.w,
        h = _this$viewport.h;
      var l = Math.floor(left / w * _this.arraySize);
      var t = Math.floor(top / h * _this.arraySize);
      var r = Math.ceil((left + width) / w * _this.arraySize);
      var b = Math.ceil((top + height) / h * _this.arraySize);

      // that info is temporary to get info why it goes over boundary
      if (_this.outOfBoundaryInfo === '') {
        var outOfBoundaryInfo = '';
        if (r > _this.arraySize) {
          outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
        }
        if (b > _this.arraySize) {
          outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
        }
        _this.outOfBoundaryInfo = outOfBoundaryInfo;
      }

      // correct values to min - 0, max - arraySize
      var result = {
        l: Math.max(0, l),
        t: Math.max(0, t),
        r: Math.min(_this.arraySize, r),
        b: Math.min(_this.arraySize, b)
      };
      return result;
    });
    _defineProperty(this, "attachAbortListeners", function () {
      _this.detachAbortListeners();
      var wheelUnbind = bind(window, {
        type: 'wheel',
        listener: function listener(e) {
          _this.setAbortReason(abortReason.scroll, e.timeStamp);
        },
        options: {
          passive: true,
          once: true
        }
      });
      var keyDownUnbind = bind(window, {
        type: 'keydown',
        listener: function listener(e) {
          _this.setAbortReason(abortReason.keypress, e.timeStamp);
        },
        options: {
          once: true
        }
      });
      var resizeUnbind = bind(window, {
        type: 'resize',
        listener: function listener(e) {
          if (getViewportWidth() !== _this.viewport.w || getViewportHeight() !== _this.viewport.h) {
            var _this$unbind$resize, _this$unbind;
            _this.setAbortReason(abortReason.resize, e.timeStamp);
            (_this$unbind$resize = (_this$unbind = _this.unbind).resize) === null || _this$unbind$resize === void 0 || _this$unbind$resize.call(_this$unbind);
            delete _this.unbind.resize;
          }
        }
      });
      _this.unbind = {
        wheel: wheelUnbind,
        keyDown: keyDownUnbind,
        resize: resizeUnbind
      };
    });
    this.arraySize = options.heatmapSize || 200;
    this.devToolsEnabled = options.devToolsEnabled || false;
    this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
    this.observers = new Observers({
      selectorConfig: options.selectorConfig || {
        id: false,
        testId: false,
        role: false,
        className: true,
        dataVC: true
      }
    });
    this.heatmap = this.getCleanHeatmap();
    this.ssrInclusiveHeatmap = this.getCleanHeatmap();
  }
  _createClass(VCObserver, [{
    key: "start",
    value: function start(_ref5) {
      var startTime = _ref5.startTime;
      this.setViewportSize();
      this.resetState();
      this.startTime = startTime;
      this.active = true;
      this.attachAbortListeners();
      this.observers.subscribeResults(this.handleUpdate);
      this.observers.observe();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.observers.disconnect();
      this.detachAbortListeners();
    }
  }, {
    key: "setSSRElement",
    value: function setSSRElement(element) {
      this.observers.setReactRootElement(element);
    }
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.observers.setReactRootRenderStart(startTime);
    }
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop() {
      var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.observers.setReactRootRenderStop(stopTime);
    }
  }, {
    key: "setAbortReason",
    value: function setAbortReason(abort, timestamp) {
      var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (this.abortReason.reason === null || this.abortReason.blocking === false) {
        this.abortReason.reason = abort;
        this.abortReason.info = info;
        this.abortReason.timestamp = timestamp;
        this.abortReason.blocking = abort !== abortReason.scroll;
        if (this.abortReason.blocking) {
          this.detachAbortListeners();
        }
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.abortReason = {
        reason: null,
        info: '',
        timestamp: -1,
        blocking: false
      };
      this.detachAbortListeners();
      this.heatmap = this.getCleanHeatmap();
      this.ssrInclusiveHeatmap = this.getCleanHeatmap();
      this.totalTime = 0;
      this.componentsLog = {};
    }
  }, {
    key: "getCleanHeatmap",
    value: function getCleanHeatmap() {
      var _this2 = this;
      return Array(this.arraySize).fill('').map(function () {
        return Array(_this2.arraySize).fill(UNUSED_SECTOR);
      });
    }
  }, {
    key: "setViewportSize",
    value: function setViewportSize() {
      this.viewport.w = getViewportWidth();
      this.viewport.h = getViewportHeight();
    }
  }, {
    key: "applyChangesToHeatMap",
    value: function applyChangesToHeatMap(a, time, heatmap) {
      var l = a.l,
        t = a.t,
        r = a.r,
        b = a.b;
      var localHeatmap = heatmap;
      for (var row = t; row < b; row++) {
        for (var col = l; col < r; col++) {
          if (localHeatmap[row] === undefined) {
            try {
              this.setAbortReason(abortReason.error, time, "index - ".concat(row));
            } catch (e) {
              this.setAbortReason(abortReason.error, time, 'row error');
            }
            return;
          } else {
            localHeatmap[row][col] = time;
          }
        }
      }
    }
  }, {
    key: "detachAbortListeners",
    value: function detachAbortListeners() {
      var unbindFns = Object.values(this.unbind);
      if (unbindFns.length > 0) {
        unbindFns.forEach(function (fn) {
          return fn();
        });
      }
      this.unbind = {};
    }
  }, {
    key: "measureStart",
    value: function measureStart() {
      this._startMeasureTimestamp = performance.now();
    }
  }, {
    key: "measureStop",
    value: function measureStop() {
      if (this._startMeasureTimestamp === -1) {
        return;
      }
      this.totalTime += performance.now() - this._startMeasureTimestamp;
      this._startMeasureTimestamp = -1;
    }
  }], [{
    key: "calculateVC",
    value: function calculateVC(_ref6) {
      var heatmap = _ref6.heatmap,
        _ref6$ssr = _ref6.ssr,
        ssr = _ref6$ssr === void 0 ? UNUSED_SECTOR : _ref6$ssr,
        componentsLog = _ref6.componentsLog,
        viewport = _ref6.viewport;
      var lastUpdate = {};
      var totalPainted = 0;
      if (ssr !== UNUSED_SECTOR) {
        var _window$document;
        var element = {
          __debug__element: (_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body,
          ignored: false,
          intersectionRect: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            x: 0,
            y: 0,
            width: viewport.w,
            height: viewport.h,
            toJSON: function toJSON() {
              return {};
            }
          },
          targetName: 'SSR'
        };
        if (!componentsLog[ssr]) {
          componentsLog[ssr] = [];
        }
        componentsLog[ssr].push(element);
      }
      heatmap.forEach(function (line) {
        line.forEach(function (entry) {
          var rounded = Math.floor(entry === UNUSED_SECTOR && ssr !== UNUSED_SECTOR ? ssr : entry);
          totalPainted += rounded !== UNUSED_SECTOR ? 1 : 0;
          if (rounded !== UNUSED_SECTOR) {
            lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
          }
        });
      });
      var entries = Object.entries(lastUpdate).map(function (a) {
        return [parseInt(a[0], 10), a[1]];
      }).sort(function (a, b) {
        return a[0] > b[0] ? 1 : -1;
      });
      var VC = VCObserver.makeVCReturnObj();
      var VCBox = VCObserver.makeVCReturnObj();
      entries.reduce(function () {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var v = arguments.length > 1 ? arguments[1] : undefined;
        var VCRatio = v[1] / totalPainted + acc;
        var time = v[0];
        VCObserver.VCParts.forEach(function (key) {
          var value = parseInt(key, 10);
          if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
            var _componentsLog$time;
            VC[key] = time;
            VCBox[key] = (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function (v) {
              return v.targetName;
            });
          }
        });
        return VCRatio;
      }, 0);
      var VCEntries = entries.reduce(function (acc, _ref7, i) {
        var _acc$abs, _componentsLog$timest;
        var _ref8 = _slicedToArray(_ref7, 2),
          timestamp = _ref8[0],
          entryPainted = _ref8[1];
        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
        var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function (v) {
          return v.targetName;
        });
        acc.abs.push([timestamp, currentlyPainted]);
        acc.rel.push({
          time: timestamp,
          vc: currentlyPaintedRatio,
          elements: logEntry
        });
        return acc;
      }, {
        abs: [],
        rel: []
      });
      return {
        VC: VC,
        VCBox: VCBox,
        VCEntries: VCEntries,
        totalPainted: totalPainted
      };
    }
  }, {
    key: "makeVCReturnObj",
    value: function makeVCReturnObj() {
      var vc = {};
      VCObserver.VCParts.forEach(function (v) {
        vc[v] = null;
      });
      return vc;
    }
  }]);
  return VCObserver;
}();
/** config * */
_defineProperty(VCObserver, "VCParts", ['25', '50', '75', '80', '85', '90', '95', '98', '99']);